import { render } from "./topblock.vue?vue&type=template&id=1d3b6a62"
import script from "./topblock.vue?vue&type=script&lang=js"
export * from "./topblock.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__